export default {
      id: "icon-mail-03-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "icons.ea799da449d35b9cdeaf2018df08853f.svg#icon-mail-03",
      toString: function () {
        return this.url;
      }
    }